<template>
  <div v-if="type === 'checkbox' && label" class="checkbox">
    <input
      type="checkbox"
      :name="name"
      :id="inputId"
      :disabled="disabled"
      :checked="value"
      :required="required"
      @change="toggle"
    />
    <label :for="inputId">
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    value: Boolean,
    name: String,
    id: String,
    label: String,
    disabled: Boolean,
    required: Boolean,
    type: {
      type: String,
      default: 'checkbox',
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    inputId() {
      return this.id || `checkbox-${this._uid}`;
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  position: relative;
  label {
    line-height: 20px;
    display: block;
    padding-left: 35px;
    position: relative;
    color: white;
  }
  input[type='checkbox'] {
    position: absolute;
    margin: 0;
    z-index: -1;
    height: 25px;
    width: 25px;
    border-radius: 0px;

    &:checked + label::before {
      border-color: $icon-fill;
      background-color: $icon-fill;
      background-position: -1px -1px;
    }
  }
  input[type='radio'] {
    display: none;

    &:checked + label {
      &::before {
        background-color: $primary;
        border-color: $primary;
      }
      &::after {
        content: '';
        background-color: $primary-white;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 7px;
        width: 11px;
        height: 11px;
        transform: translateY(-50%);
      }
    }
    + label::before {
      border-radius: 50%;
    }
  }
}

.toggle {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 372px;
  color: black;

  input {
    display: none;

    &:checked + label span {
      &::before {
        background-color: $primary;
      }
      &::after {
        left: 33px;
      }
    }
    &:disabled + label {
      cursor: default;
      opacity: 0.5;
    }
  }
  label {
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    cursor: pointer;
    display: inline-block;
    padding-left: 70px;
    position: relative;

    span {
      display: block;

      &::before {
        content: '';
        background-color: #aaaaaa;
        border-radius: 12px;
        position: absolute;
        top: 50%;
        left: 0;
        width: 55px;
        height: 24px;
        transform: translateY(-50%);
        transition: background-color 200ms;
      }
      &::after {
        content: '';
        background-color: $primary-white;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 2px;
        width: 20px;
        height: 20px;
        transform: translateY(-50%);
        transition: left 200ms, right 200ms;
      }
    }
  }
  &.label-before {
    label {
      padding-left: 0;
      padding-right: 70px;

      span {
        &::before {
          left: auto;
          right: 0;
        }
        &::after {
          left: auto;
          right: 33px;
        }
      }
    }
    input:checked + label span::after {
      left: auto;
      right: 2px;
    }
  }
}
input[type='checkbox'] {
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid $primary;
  background-color: white;
  border-radius: 3px;
  width: 22px;
  height: 22px;
  vertical-align: bottom;
  outline: none;
  cursor: pointer;
}
input[type='checkbox']:after {
  content: '';
  position: absolute;
  top: 40%;
  left: 50%;
  width: 8px;
  height: 16px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: translate(-50%, -50%) rotateZ(40deg);
}
input[type='checkbox']:checked {
  background-color: $primary;
}
</style>
